import type { SocialPlatform } from '@pulsify/shared/dto'
import { Facebook, Instagram, type LucideIcon } from 'lucide-react'
import type { CSSProperties } from 'react'
import * as m from '~/paraglide/messages'

interface PlatformUi {
  icon: LucideIcon
  label: () => string
  /** Official platform brand fill for the icon tile when connected. */
  brandStyle: CSSProperties
}

export const PLATFORM_UI: Record<SocialPlatform, PlatformUi> = {
  facebook: {
    icon: Facebook,
    label: m.crosspostingFacebook,
    brandStyle: { backgroundColor: '#1877F2', color: '#ffffff' },
  },
  instagram: {
    icon: Instagram,
    label: m.crosspostingInstagram,
    brandStyle: {
      backgroundImage: 'linear-gradient(45deg, #F58529, #DD2A7B, #8134AF, #515BD4)',
      color: '#ffffff',
    },
  },
}
